import {Tag} from 'antd';
import dayjs from 'dayjs';
import React, {useContext, useMemo, useRef, useState} from "react";
import BannerEditModal from "./BannerEditModal";
import {getBannerImageUrl} from "../../common/S3";
import {Sorter} from "../../shared/components/Sorter";
import {AuthContext} from "../../shared/contexts/authContext";
import TablePage from "../../pages/tablePage/TablePage";
import {onOffValue} from "../../shared/utils/enum";

const Banner = () => {
    const [rowData, setRowData] = useState({});
    const refreshRef = useRef(null);

    const {currentUser} = useContext(AuthContext);

    const columns = useMemo(() => ([
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: '이름',
            dataIndex: 'name',
            search: true,
        },
        {
            title: 'On/Off',
            dataIndex: 'onOff',
            render: (_, {onOff}) => (
                <Tag color={onOffValue[onOff].color}>
                    {onOffValue[onOff].text}
                </Tag>
            ),
            filters: [
                {
                    text: 'On',
                    value: 1,
                },
                {
                    text: 'Off',
                    value: 0,
                },
            ],
            onFilter: (value, record) => record.onOff === value,
        },
        {
            title: '우선 순위',
            dataIndex: 'priority',
        },
        {
            title: '강제 노출',
            dataIndex: 'isForcedExposure',
            render: (_, {isForcedExposure}) => (
                <Tag color={onOffValue[isForcedExposure].color}>
                    {onOffValue[isForcedExposure].text}
                </Tag>
            ),
            filters: [
                {
                    text: 'On',
                    value: 1,
                },
                {
                    text: 'Off',
                    value: 0,
                },
            ],
            onFilter: (value, record) => record.isForcedExposure === value,
        },
        {
            title: 'Start',
            dataIndex: 'begin',
            render: (begin) => dayjs.unix(begin).format('YYYY-MM-DD'),
        },
        {
            title: 'End',
            dataIndex: 'end',
            render: (end) => dayjs.unix(end).format('YYYY-MM-DD'),
            sorter: (a, b) => Sorter.DATE(a.end, b.end)
        },
        {
            title: 'Banner',
            dataIndex: 'banners',
            render: (banners) => <img
                src={getBannerImageUrl(currentUser.target, banners[0].img)}
                alt="파일 없음" style={{width: '100%', height: '50px', objectFit: 'contain'}}/>
        },
        {
            title: 'Link',
            dataIndex: 'banners',
            render: (banners) => {
                const link = banners[0].link;
                return link.length > 50 ? `${link.substring(0, 50)}...` : link;
            },
        },
        {
            title: 'Target',
            dataIndex: 'target',
            render: (target) => target === 0 ? 'All' : 'Target',
        },
        {
            title: 'Action',
            dataIndex: 'action',
            render: (_, {action}) => {
                let color, text;
                switch (action) {
                    case 0:
                        color = 'red';
                        text = 'WebView';
                        break;
                    case 1:
                        color = 'green';
                        text = 'openURL';
                        break;
                    case 2:
                        color = 'blue';
                        text = 'UI';
                        break;
                    default:
                        color = 'lightgray';
                        text = 'Unknown';
                }
                return <Tag color={color}>{text}</Tag>;
            },
            filters: [
                {
                    value: 0,
                    label: 'WebView'
                },
                {
                    value: 1,
                    label: 'openURL'
                },
                {
                    value: 2,
                    label: 'UI'
                },
            ],
            onFilter: (value, record) => record.widget === value,
        }
    ]), [currentUser.target]);

    const props = {
        columns,
        rowData,
        setRowData,
        modal: BannerEditModal,
        refreshRef,
        url: 'banner',
        buttonText: '신규 배너 추가',
    }

    return (
        <TablePage {...props} />
    );
};

export default Banner;